var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertSub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 13.852,
    height: 13.962,
    viewBox: "0 0 13.852 13.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_84",
    d: "M10.94 8.964a.631.631 0 1 1 1.262 0v3.751a.631.631 0 1 1-1.262 0z",
    className: "prefix__cls-1",
    style: {
      fill: "#8b8c8c"
    },
    "data-name": "Trazado 84",
    transform: "translate(-4.676 -3.663)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Elipse_6",
    cx: 0.789,
    cy: 0.792,
    className: "prefix__cls-1",
    style: {
      fill: "#8b8c8c"
    },
    "data-name": "Elipse 6",
    rx: 0.789,
    ry: 0.792,
    transform: "translate(6.106 10.363)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_85",
    fill: "#8b8c8c",
    fillRule: "evenodd",
    d: "M8.025 3.09a.126.126 0 0 0-.227 0L2.669 13.5a.127.127 0 0 0 .114.184H13.1a.127.127 0 0 0 .114-.184zm-.795-1.7a.756.756 0 0 1 1.356 0l6.207 12.463a.76.76 0 0 1-.675 1.077H1.767a.754.754 0 0 1-.675-1.1z",
    "data-name": "Trazado 85",
    transform: "translate(-1.01 -.963)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSub);
export default __webpack_public_path__ + "static/media/alert-sub.48372ee7.svg";
export { ForwardRef as ReactComponent };